import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SketchPicker } from 'react-color';
import { Button } from '@weezevent/nacre';
import Style from './color-picker.module.css';

export const colors = [
    '#d0021b',
    '#f5a623',
    '#f8e71c',
    '#8b572a',
    '#7ed321',
    '#417505',
    '#bd10e0',
    '#ff6900',
    '#0032fa',
    '#7bdcb5',
    '#00d084',
    '#8ed1fc',
    '#0693e3',
    '#abb8c3',
    '#eb144c',
    '#f78da7'
];

export default function ColorPicker({ show = true, component = SketchPicker, onClickAway = () => {}, className, ...rest }) {
    let Component = component;
    const { t } = useTranslation();
    const ref = React.useRef(null);

    const clickAway = React.useCallback(
        ({ target }) => {
            if (!show || !ref.current) {
                return;
            }

            if (!ref.current.contains(target)) {
                onClickAway();
            }
        },
        [onClickAway, ref, show]
    );

    React.useEffect(() => {
        window.addEventListener('click', clickAway);

        return () => {
            window.removeEventListener('click', clickAway);
        };
    }, [clickAway]);

    if (!show) {
        return null;
    }

    return (
        <div ref={ref} className={`${Style['container-block']} ${className}`}>
            <div className={Style['color-container']}>
                <Component className={Style['color-picker-block']} presetColors={colors} {...rest} />
                <Button className={Style['color-validator']} primary inverted onClick={onClickAway}>
                    {t('ticket.common.action.validate')}
                </Button>
            </div>
        </div>
    );
}

ColorPicker.propTypes = {
    component: PropTypes.node,
    onClickAway: PropTypes.func,
    show: PropTypes.bool
};
